import { reactive } from "vue";

const timers = new Map();
let nextId = 1;
let activeConfirmResolve = null;

export const feedbackState = reactive({
  messages: [],
  confirm: null,
});

const normalizeMessage = (input, type) => {
  if (typeof input === "string") return { message: input, type };
  return { ...input, type: input?.type || type };
};

const remove = (id) => {
  const index = feedbackState.messages.findIndex((item) => item.id === id);
  if (index >= 0) feedbackState.messages.splice(index, 1);
  const timer = timers.get(id);
  if (timer) window.clearTimeout(timer);
  timers.delete(id);
};

const show = (input, defaultType = "info") => {
  const options = normalizeMessage(input, defaultType);
  const duplicate = feedbackState.messages.find(
    (item) =>
      item.type === (options.type || "info") &&
      item.title === (options.title || "") &&
      item.message === (options.message || "")
  );

  if (duplicate) {
    const duration = Number.isFinite(options.duration) ? options.duration : 3200;
    const timer = timers.get(duplicate.id);
    if (timer) window.clearTimeout(timer);
    duplicate.duration = duration;
    if (duration > 0) {
      timers.set(duplicate.id, window.setTimeout(() => remove(duplicate.id), duration));
    }
    return duplicate.id;
  }

  const id = nextId++;
  const item = {
    id,
    type: options.type || "info",
    title: options.title || "",
    message: options.message || "",
    duration: Number.isFinite(options.duration) ? options.duration : 3200,
  };

  feedbackState.messages.push(item);
  if (feedbackState.messages.length > 4) remove(feedbackState.messages[0].id);

  if (item.duration > 0) {
    timers.set(id, window.setTimeout(() => remove(id), item.duration));
  }
  return id;
};

const closeAll = () => {
  [...feedbackState.messages].forEach((item) => remove(item.id));
};

const confirm = (input, title, options = {}) => {
  const config =
    typeof input === "object"
      ? input
      : { ...options, message: input, title: title || options.title };

  if (activeConfirmResolve) activeConfirmResolve(false);

  return new Promise((resolve) => {
    activeConfirmResolve = resolve;
    feedbackState.confirm = {
      title: config.title || "请确认",
      message: config.message || "是否继续当前操作？",
      confirmText: config.confirmText || config.confirmButtonText || "确认",
      cancelText: config.cancelText || config.cancelButtonText || "取消",
      tone: config.tone || config.type || "primary",
      closeOnBackdrop: config.closeOnBackdrop !== false,
    };
  });
};

const resolveConfirm = (result) => {
  const resolve = activeConfirmResolve;
  activeConfirmResolve = null;
  feedbackState.confirm = null;
  resolve?.(result);
};

export const feedback = {
  show,
  info: (input) => show(input, "info"),
  success: (input) => show(input, "success"),
  warning: (input) => show(input, "warning"),
  error: (input) => show(input, "error"),
  close: remove,
  closeAll,
  confirm,
  resolveConfirm,
};

export default feedback;
